import { useSyncExternalStore } from 'react'

import {
  TIME_FORMAT_PREFERENCE_EVENT,
  timeFormatPreferenceStorage
} from '../utils/timeFormatPreferenceStorage'

function subscribe(onChange: () => void): () => void {
  window.addEventListener(TIME_FORMAT_PREFERENCE_EVENT, onChange)
  function handleStorage(e: StorageEvent) {
    if (e.key === null || e.key === 'use24HourTime') {
      onChange()
    }
  }
  window.addEventListener('storage', handleStorage)
  return () => {
    window.removeEventListener(TIME_FORMAT_PREFERENCE_EVENT, onChange)
    window.removeEventListener('storage', handleStorage)
  }
}

interface UseTimeFormatResult {
  use24Hour: boolean
  setUse24Hour: (value: boolean) => void
}

const useTimeFormat = (): UseTimeFormatResult => {
  const use24Hour = useSyncExternalStore(
    subscribe,
    timeFormatPreferenceStorage.get,
    timeFormatPreferenceStorage.get
  )
  return { use24Hour, setUse24Hour: timeFormatPreferenceStorage.set }
}

export default useTimeFormat
